export default function roleFilter(subcribe) {
  if (!subcribe) return 'Обычный';
  const role_list = [
    {name: 'Премиум', id: 1},
    {name: 'Обычный', id: 2},
  ];
  return role_list.find(el => el.id === subcribe).name;
}